<template lang="pug">
    div
        ul
            li(v-for="app in pData.applications")
                span(v-html="fitment(app)")
</template>

<script>
export default {
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
    methods: {
        fitment(obj) {
            // this was made generically so that if/when we add more junk to YMMBBEXYZ then XYZ would magically add to the end
            const base = Object.assign({}, obj)
            let str = `${base.year} ${base.make} ${base.model}`
            delete base.year
            delete base.make
            delete base.model

            if (base.notes) {
                str += `, ${base.notes}`
                delete base.notes
            }

            Object.keys(base).forEach((key) => {
                str += `, ${base[key]}`
            })

            return str
        },
    },
}
</script>
